var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.authLoginLoading,
          expression: "authLoginLoading",
        },
      ],
      staticClass: "login-panel",
    },
    [
      _vm.businessType === "login" && _vm.loginType !== "wx"
        ? _c("div", { staticClass: "login-change-corner" }, [
            _c("div", { staticClass: "triangle-mask" }),
            _vm.loginType === "normal"
              ? _c("div", {
                  staticClass: "icon-box icon-code",
                  on: {
                    click: function ($event) {
                      return _vm.loginTypeChange("scan")
                    },
                  },
                })
              : _vm._e(),
            _vm.loginType === "scan"
              ? _c("div", {
                  staticClass: "icon-box icon-pwd",
                  on: {
                    click: function ($event) {
                      return _vm.loginTypeChange("normal")
                    },
                  },
                })
              : _vm._e(),
          ])
        : _vm._e(),
      _vm.loginType === "normal"
        ? _c("login-panel-normal")
        : _c("login-panel-scan"),
      _vm.businessType === "login"
        ? _c("div", { staticClass: "bottom-bar" }, [
            _vm.loginType !== "wx"
              ? _c("div", { staticClass: "others-login" }, [
                  _c("div", [_vm._v("其它登录方式：")]),
                  _c("div", {
                    staticClass: "wx-login",
                    on: { click: _vm.getWxAuthUrl },
                  }),
                ])
              : _vm._e(),
            _vm.loginType === "normal" && _vm.tabActive === "password"
              ? _c(
                  "div",
                  {
                    staticClass: "forget-pwd",
                    on: { click: _vm.changeBusinessType },
                  },
                  [_vm._v("\n      忘记密码\n    ")]
                )
              : _vm._e(),
          ])
        : _c(
            "div",
            { staticClass: "go-login", on: { click: _vm.changeBusinessType } },
            [_vm._v("返回至登录页")]
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }